export default "__VITE_ASSET__CNuRatjm__"